import { gql } from 'apollo-angular';

const CREATE_RFP = gql`
  mutation createRfp(
    $buyerId: Long!
    $categoryId: Long
    $categorizationSchemeId: Long
    $sellerId: Long
  ) {
    createRfp(
      createRfpRequest: {
        buyerId: $buyerId
        categoryId: $categoryId
        categorizationSchemeId: $categorizationSchemeId
        sellerId: $sellerId
      }
    ) {
      id
    }
  }
`;

export default CREATE_RFP;
